import { prop } from "../../decorators/property";

export class ParagraphFilterModel extends Backbone.AssociatedModel {

    @prop() public materialtype: string;
    @prop() public count: number;
    @prop() public name: string;
    @prop() public Id: number;
    @prop() public color: string;

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/paragraph-filter.ts